import React from 'react';
import PropTypes from 'prop-types';
import {
  SomaBadge,
} from '@soma/react';

import {
  BlackUICard,
  BlackUICardContent,
  SomaUIArrowUpIcon,
  SomaUIArrowDownIcon,
  CustomBadge,
  CustomOperationLogo,
  CustomTitle,
  CustomSubTitle,
  CustomObjectiveText,
  CustomCategoryTitle,
  CustomCategorySubTitle,
  CustomCardHeader,
  CustomCardItem,
  CustomContainer,
  TitleContainer,
} from './styles';

const OperationCard = ({
  isHighlight,
  tagList,
  logoSRC,
  title,
  isNewOperations,
  subtitle,
  maxProfit,
  maxLoss,
  commission,
  price,
  closingDate,
  objective,
  codigoCamaraCompensasao,
}) => (
  <BlackUICard>
    <CustomCardHeader>
      {tagList.map(tag => (<CustomBadge key={tag} value={tag} />))}
      {isHighlight && <CustomBadge value="Destaque" bgColor="#FFC709" txtColor="black" txtFontWeight="bold" />}
    </CustomCardHeader>
    <BlackUICardContent>
      <CustomCardItem isOperationInformation>
        <CustomOperationLogo src={logoSRC} name={title} />
        <CustomContainer margin="0 0 0 1rem">
          <TitleContainer>
            <CustomTitle>{title}</CustomTitle>
            {!isNewOperations && (
              <SomaBadge variant="default" size="md" value={codigoCamaraCompensasao === 1 ? 'BMF' : 'CETIP'} />
            )}
          </TitleContainer>
          <CustomSubTitle>{subtitle}</CustomSubTitle>
        </CustomContainer>
      </CustomCardItem>

      <CustomCardItem isUnitaryValue>
        {maxProfit && (
          <CustomContainer margin="0">
            <CustomCategoryTitle>Lucro máx. unitário</CustomCategoryTitle>
            <CustomContainer flexDirection="row" alignItems="center">
              <SomaUIArrowUpIcon />
              <CustomCategorySubTitle>{maxProfit}</CustomCategorySubTitle>
            </CustomContainer>
          </CustomContainer>
        )}
        {maxLoss && (
          <CustomContainer margin="0">
            <CustomCategoryTitle>Prejuízo máx. unitário</CustomCategoryTitle>
            <CustomContainer flexDirection="row" alignItems="center">
              <SomaUIArrowDownIcon />
              <CustomCategorySubTitle>{maxLoss}</CustomCategorySubTitle>
            </CustomContainer>
          </CustomContainer>
        )}
      </CustomCardItem>

      <CustomCardItem isPercentageValue>
        <CustomContainer>
          <CustomCategoryTitle>Comissão</CustomCategoryTitle>
          <CustomCategorySubTitle>{commission}</CustomCategorySubTitle>
        </CustomContainer>

        <CustomContainer>
          <CustomCategoryTitle>Preço</CustomCategoryTitle>
          <CustomCategorySubTitle>{price}</CustomCategorySubTitle>
        </CustomContainer>
      </CustomCardItem>

      <CustomCardItem isDateValue>
        <CustomCategoryTitle>Encerramento</CustomCategoryTitle>
        <CustomCategorySubTitle>{closingDate}</CustomCategorySubTitle>
      </CustomCardItem>

      <CustomCardItem isObjectiveValue>
        <CustomCategoryTitle>Objetivo</CustomCategoryTitle>
        <CustomObjectiveText>{objective}</CustomObjectiveText>
      </CustomCardItem>
    </BlackUICardContent>
  </BlackUICard>
);

OperationCard.propTypes = {
  isHighlight: PropTypes.bool.isRequired,
  tagList: PropTypes.arrayOf(PropTypes.string).isRequired,
  logoSRC: PropTypes.string.isRequired,
  title: PropTypes.string.isRequired,
  codigoCamaraCompensasao: PropTypes.number.isRequired,
  subtitle: PropTypes.string.isRequired,
  maxProfit: PropTypes.string.isRequired,
  maxLoss: PropTypes.string.isRequired,
  commission: PropTypes.string.isRequired,
  price: PropTypes.string.isRequired,
  closingDate: PropTypes.string.isRequired,
  objective: PropTypes.string.isRequired,
};

export default OperationCard;
